




















































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import { ComposeCates$ } from "@/request/jxgl";
@Component({})
export default class XtkAddCateDialog extends Vue {
  @Prop()
  private ifVisible: any;
  @Prop()
  private cates: any;
  private cs: any[] = [];
  private get visible() {
    return this.ifVisible;
  }
  private set visible(val) {
    this.$emit("update:ifVisible", val);
  }
  private addCate() {
    this.cs.unshift({ 分类名称: "" });
  }
  private deleteThis(index) {
    this.cs.splice(index, 1);
  }
  private cancel() {
    this.$emit("update:ifVisible", false);
  }
  /**
   * @description 检验分类名称
   */
  private validCateName(name) {
    console.log(name);
    if (name === "典型舌图实训题" || name === "舌诊综合实训题") {
      this.$message.warning("分类名称不能和系统内置的实训题命名相同");
    }
  }
  private save() {
    let valid = true;
    this.cs.forEach((c: any) => {
      if (!c["分类名称"]) {
        valid = false;
        this.$message.warning("分类名称不能为空");
      }
      if (
        (c["分类名称"] === "典型舌图实训题" &&
          c["cate_id"] !== "典型舌图实训题") ||
        (c["分类名称"] === "舌诊综合实训题" &&
          c["cate_id"] !== "舌诊综合实训题")
      ) {
        valid = false;
        this.$message.warning("分类名称不能和系统内置的实训题命名相同");
      }
    });
    if (!valid) {
      return;
    }
    const params = {
      分类: this.cs,
    };
    ComposeCates$(this, params).then(() => {
      this.$message.success("编辑成功");
      this.$emit("update:ifVisible", false);
      this.$emit("change");
    });
  }
  private mounted() {
    this.cs = _.cloneDeep(this.cates);
    console.log("cs", this.cs);
  }
}
